import { useCallback, useRef } from 'react';

import type { FormInstance } from '@arco-design/web-react';

import { useOptionalResourceFormContext } from './context';

/**
 * 弹窗确认写回 innerForm 后主动询价（不单靠 Form.useWatch）。
 * 无 ResourceFormProvider / 无 calculatePriceData 时为 no-op（直建）。
 */
export function useScheduleResourceFormPriceRefresh() {
  const ctx = useOptionalResourceFormContext();
  const calculatePriceDataRef = useRef(ctx?.calculatePriceData);
  calculatePriceDataRef.current = ctx?.calculatePriceData;

  return useCallback((innerForm: FormInstance, options?: { force?: boolean }) => {
    const calculatePriceData = calculatePriceDataRef.current;
    if (!calculatePriceData) return;
    const force = options?.force !== false;
    /** setFieldsValue 提交后再读表；微任务偶发仍读到旧值，用 timeout 0 */
    window.setTimeout(() => {
      void calculatePriceData({}, innerForm, force ? { force: true } : undefined);
    }, 0);
  }, []);
}
